// consts
import { CALENDAR_TYPE } from 'app/config/calendar_type';
import { FREQUENCY } from 'app/config/frequency_type';
// utils
import _ from 'lodash';
import { toMinutes, inMinutes } from 'app/utils';
import { differenceInDays } from 'date-fns';

export default class Amount {
  constructor(calendarType) {
    // tipo de frequência
    this._calendarTypeId = calendarType;
  }

  _calcPeriodInDays({ continuousUse, period }, padDetails) {
    if (continuousUse) {
      const { endDate, startDate } = padDetails;

      const differenceDays = differenceInDays(new Date(endDate), new Date(startDate));

      period = differenceDays;
    }

    return period;
  }

  _calcPeriodInMinutes({ continuousUse, period }, padDetails) {
    if (continuousUse) {
      const { endDate, startDate } = padDetails;

      const differenceDays = differenceInDays(new Date(endDate), new Date(startDate));

      period = differenceDays;
    }

    const periodInMinutes = 1440 * period;

    return periodInMinutes;
  }

  // frequência: a cada
  _calculateEvery(padPrescription, padDetails) {
    const { frequencyAmount, frequencyTypeId, period, continuousUse, dose } = padPrescription;

    const frequency = toMinutes(frequencyAmount, frequencyTypeId);
    const periodInMinutes = this._calcPeriodInMinutes({ continuousUse, period }, padDetails);
    const amount = Math.floor(periodInMinutes / frequency) * dose;

    return _.parseInt(amount);
  }

  // frequência: vezes por
  _calculateTimesPer(padPrescription, padDetails) {
    const { frequencyAmount, frequencyTypeId, period, continuousUse, dose } = padPrescription;

    // por mês
    if (frequencyTypeId === FREQUENCY.MONTH_ID) {
      const amount = frequencyAmount * dose;
      return _.parseInt(amount);
    }

    const periodInMinutes = this._calcPeriodInMinutes({ continuousUse, period }, padDetails);
    const frequencyTypeInMinutes = inMinutes(frequencyTypeId);
    const amount = frequencyAmount * (periodInMinutes / frequencyTypeInMinutes) * dose;

    return _.parseInt(amount);
  }

  // frequência: por turno
  _calculatePerShift({ ...padPrescription }, padDetails) {
    const { shifts, period, continuousUse, dose } = padPrescription;
    const periodInDays = this._calcPeriodInDays({ continuousUse, period }, padDetails);
    const timesADay = shifts.length;

    const amount = timesADay * periodInDays * dose;

    return _.parseInt(amount);
  }

  calculate(padPrescription, padDetails) {
    const { EVERY, TIMES_PER, PER_SHIFT } = CALENDAR_TYPE;
    // const { frequencyAmount, frequencyTypeId, period } = padPrescription;

    if (this._calendarTypeId === EVERY) {
      return this._calculateEvery({ ...padPrescription }, padDetails);
    }

    if (this._calendarTypeId === TIMES_PER) {
      return this._calculateTimesPer({ ...padPrescription }, padDetails);
    }

    if (this._calendarTypeId === PER_SHIFT) {
      return this._calculatePerShift({ ...padPrescription }, padDetails);
    }
  }
}
